import { initializeApp } from 'firebase/app';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
	apiKey: process.env.MIX_API_KEY,
	authDomain: process.env.MIX_API_AUTH_DOMAIN,
	projectId: process.env.MIX_API_PROJECT_ID,
	storageBucket: process.env.MIX_API_STORAGE_BUCKET,
	messagingSenderId: process.env.MIX_API_MESSAGING_SENDER_ID,
	appId: process.env.MIX_API_APP_ID,
	//   measurementId: process.env.MIX_API_MEASUREMENT_ID
};
const app = initializeApp(firebaseConfig);

const db = initializeFirestore(app, {
	experimentalForceLongPolling: true,
});
const eduDb = initializeFirestore(
	app,
	{
		experimentalForceLongPolling: true,
	},
	process.env.MIX_AI_DB_NAME ?? 'testfedb',
);

const storage = getStorage(app);
const auth = getAuth(app);
const googleAuthProvider = new GoogleAuthProvider();
// Initialize Firebase Cloud Messaging and get a reference to the service
let messaging = null;
if (process.env.MIX_APP_ENV != 'local') {
	try {
		messaging = getMessaging(app);
	} catch (e) {
		console.warn('Firebase Messaging is not supported in this browser:', e.message);
	}
}

export { db, eduDb, storage, auth, googleAuthProvider, messaging, getToken, onMessage };
